import { config } from "@/config";
import type { CustomSystemPrompt, NoteType } from "@rebuild/shared";
import { Provider } from "@/providers/http.provider";

class SystemPromptProvider extends Provider {
  constructor() {
    super({
      baseURL: `${config.baseAPIUrl}/rest/`,
    });
  }

  async getSystemPrompt(noteType: NoteType): Promise<{ success: boolean; data: CustomSystemPrompt | null }> {
    try {
      const response = await super.get<{
        success: boolean;
        data: CustomSystemPrompt;
      }>(`organizations/systemPrompt?noteType=${encodeURIComponent(noteType)}`);

      return response;
    } catch (error) {
      console.warn(`Unable to fetch system prompt for ${noteType}:`, error);
      return { success: false, data: null };
    }
  }
}

export default new SystemPromptProvider();
